import AppCustomersIndex from "./customer.vue";
import AppCustomersList from "./list/list.vue";
import AppCustomersItem from "./item/item.vue";

const routes = [
  {
    path: "/customer",
    component: AppCustomersIndex,
    meta: {
      auth: {
        roles: "customer.index",
        redirect: { name: "auth.login" },
        forbiddenRedirect: "/403"
      }
    },
    children: [
      {
        path: "",
        name: "customer.index",
        component: AppCustomersList,
        meta: {
          auth: {
            roles: "customer.index",
            redirect: { name: "auth.login" }
          }
        }
      },
      {
        path: "create",
        name: "customer.create",
        component: AppCustomersItem,
        meta: {
          auth: {
            roles: "customer.create",
            redirect: { name: "customer.index" }
          }
        }
      },
      {
        path: ":id",
        name: "customer.edit",
        component: AppCustomersItem,
        meta: {
          auth: {
            roles: "customer.update",
            redirect: { name: "customer.index" }
          }
        }
      }
    ]
  }
];

export default routes;
